import Paper from '@mui/material/Paper'
import React from 'react'
import ThumbsUp from '../../images/ThumbsUp.svg'
import ThumbsDown from '../../images/ThumbsDown.svg'
import { Graph } from '../graph'
import * as S from './styles'
import * as SS from '../result/styles.js'
import { transform } from '../calcs/retirementDataTransform.js'
import { SmoothImage} from '../SmoothImageLoad'

const whatsappLink = "https://api.whatsapp.com/send?phone=5548999286828&text=Ol%C3%A1!%20Quero%20uma%20vida%20financeira%20tranquila%2C%20quero%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20Monefica!"

const PositiveDescription = ({ handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsUp} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em'  }}>
			<strong>PARABÉNS!</strong> Você está no caminho certo, agora é se controlar para manter o plano. O Monefica te ajuda a acompanhar esse percurso.
			<br/><br/>
			<strong>Quer ficar atento as oportunidades de antecipar ou aumentar sua aposentadoria?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			handleClickConversionDialogOpen()
		}} variant="contained" color="primary">SIM! por e-mail!</S.CenteredButton>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
		}} variant="contained" color="primary">SIM! pelo whatsapp!</S.CenteredButton>
	</SS.Row>
</Paper>

const NegativeDescription = ({ handleClickConversionDialogOpen }) => <Paper style={{
	padding: '20px 16px ',
	margin: 20,
	maxWidth: 900
}}>
	<SS.Row>
		<div style={{height: 40, width: 40}}>
			<SmoothImage src={ThumbsDown} height={40} width={40}/>
		</div>
		<SS.Text style={{ paddingLeft: 12, lineHeight: '1.4em' }}>
			<strong>Opa!</strong> Dessa forma você não alcança sua independencia financeira. Tente alterar a idade, renda ou contribuição mensal. Esse planejamento não é fácil, mas o Monefica pode te ajudar.
			<br/><br/>
			<strong>Quer uma análise mais realista das suas finanças e ter a acesso a dicas importantes?</strong>
		</SS.Text>
	</SS.Row>
	<SS.Row>
		<S.CenteredButton onClick={() => {
			handleClickConversionDialogOpen()
		}} variant="contained" color="primary">SIM! por e-mail!</S.CenteredButton>
		<S.CenteredButton onClick={() => {
			window.open(whatsappLink, '_blank');
		}} variant="contained" color="primary">SIM! pelo whatsapp!</S.CenteredButton>
	</SS.Row>
</Paper>

export function ResultDescription(props) {
	const result = transform(props.data)
	const graphData = result.retirementArray
	const descriptionResult = result.positiveResult
	return (<SS.Container>
		<div>
			{descriptionResult ?
				<PositiveDescription handleClickConversionDialogOpen={props.handleClickConversionDialogOpen}/> :
				<NegativeDescription handleClickConversionDialogOpen={props.handleClickConversionDialogOpen}/>}
			<Graph data={graphData}/>
		</div>
	</SS.Container>)
}
